import React from "react";
import { Form } from "react-bootstrap";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel"; // Assuming this component is custom for showing feedback

const getFieldCSSClasses = (touched, errors) => {
  let classes = "form-control mt-2";

  if (touched && errors) {
    classes += " is-invalid"; // Bootstrap class for invalid state
  } else if (touched && !errors) {
    classes += " is-valid"; // Bootstrap class for valid state
  }

  return classes;
};

export function Input({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  ...props
}) {
  return (
    <Form.Group controlId={field.name}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control
        type={type}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        isInvalid={touched[field.name] && !!errors[field.name]} // React Bootstrap's native `isInvalid` prop
        isValid={touched[field.name] && !errors[field.name]} // React Bootstrap's native `isValid` prop
        {...field}
        {...props}
      />

      {/* Conditionally render feedback label if errors exist */}
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </Form.Group>
  );
}
